import type { RtcConnection } from 'features/sip/interfaces';

export type TrackKind = 'audio' | 'video';

export interface ReceiverTrackSelection {
  track: MediaStreamTrack | undefined;
  receiver: RTCRtpReceiver | undefined;
}

/**
 * Select the best receiver track of a given kind from an RTCPeerConnection.
 * Prefers the last receiver with a live-readyState track; falls back to the
 * last receiver of the given kind overall.
 */
export const selectReceiverTrackByKind = (
  rtcConnection: RtcConnection,
  kind: TrackKind
): ReceiverTrackSelection => {
  const allReceivers = rtcConnection
    .getReceivers()
    .filter((receiver) => receiver.track?.kind === kind);

  const liveReceivers = allReceivers.filter(
    (receiver) => receiver.track?.readyState === 'live'
  );

  const selectedReceiver =
    liveReceivers.at(-1) ?? allReceivers.at(-1) ?? undefined;

  return {
    track: selectedReceiver?.track ?? undefined,
    receiver: selectedReceiver,
  };
};
